import React from 'react';
import Parent from "../common/Parent";
import PropTypes from "prop-types";
import classnames from "classnames";

const AccountInformation = props => {
  const {firstName, onFieldChange, onFieldBlur, lastName, email} = props;

  return (
      <Parent>
        <div className="card-header">
          <h2>Manage account information</h2>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className={classnames('form-group', {'invalid': !firstName.isValid && firstName.touched})}>
                <label htmlFor="first-name">First Name</label>
                <input type="text" id="first-name" className="form-control" placeholder="First name" name="firstName"
                       value={firstName.value} onChange={onFieldChange} onBlur={onFieldBlur}/>
                {!firstName.isValid && firstName.touched && (
                    <p className="error-msg">{firstName.errorMessage}</p>)}
              </div>
              <div className="form-group">
                <label htmlFor="last-name">Last Name</label>
                <input type="text" id="last-name" className="form-control" placeholder="Last name"
                       value={lastName.value} name="lastName" onChange={onFieldChange} onBlur={onFieldBlur}/>
                {!lastName.isValid && lastName.touched && (
                    <p className="error-msg">{lastName.errorMessage}</p>)}
              </div>
              <div className={classnames('form-group', {'invalid': !email.isValid && email.touched})}>
                <label htmlFor="email-address">Email address</label>
                <input type="text" id="email-address" className="form-control" placeholder="Email address"
                       value={email.value} onChange={onFieldChange} onBlur={onFieldBlur} name="email"/>
                {!email.isValid && email.touched && (
                    <p className="error-msg">{email.errorMessage}</p>)}
              </div>
              <button type="button" className="btn btn-lg btn-secondary" onClick={props.openModal}>Change password
              </button>
            </div>
          </div>
        </div>
      </Parent>
  );
};

AccountInformation.propTypes = {
  openModal: PropTypes.func.isRequired,
  firstName: PropTypes.object.isRequired,
  lastName: PropTypes.object.isRequired,
  email: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired
};

export default AccountInformation;



// WEBPACK FOOTER //
// ./src/components/AccountInformation/AccountInformation.jsx